// extracted by mini-css-extract-plugin
export default {"container":"laRjV","meta-item":"lzJsZ","heading":"fb2Wk","value":"m8oi5","icon":"FHZPk"};